import { render, staticRenderFns } from "./StoryCollapseButton.vue?vue&type=template&id=29fbd808&scoped=true&"
import script from "./StoryCollapseButton.vue?vue&type=script&lang=js&"
export * from "./StoryCollapseButton.vue?vue&type=script&lang=js&"
import style0 from "./StoryCollapseButton.vue?vue&type=style&index=0&id=29fbd808&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fbd808",
  null
  
)

export default component.exports